import cx from "classnames"
import React, { useContext } from "react"
import * as styles from "./styles.module.scss"
import { NavContext } from "../Document"

export enum PaddingTop {
  Navbar = "hasNavbar",
  SubNavbar = "hasSubNavbar",
}

interface PageWrapperProps {
  children: React.ReactNode
  paddingTop?: PaddingTop
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  paddingTop,
  ...props
}) => {
  const { isNavOpen } = useContext(NavContext)
  return (
    <div
      {...props}
      className={cx({
        [styles.pageWrapper]: true,
        [styles[paddingTop]]: paddingTop,
        [styles.navOpen]: isNavOpen,
      })}
    >
      {children}
    </div>
  )
}

export default PageWrapper
